import { getDefaultStore } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const lastTradeSymbolAtom = atomWithStorage<string | null>(
	"trade_last_symbol",
	null,
);

export function getLastTradeSymbol(): string | null {
	return getDefaultStore().get(lastTradeSymbolAtom);
}

export function setLastTradeSymbol(symbol: string): void {
	const trimmed = symbol.trim();
	getDefaultStore().set(lastTradeSymbolAtom, trimmed || null);
}
